import "./index.scss";
import "../../locales/i18n";

import React from "react";
import { useTranslation } from "react-i18next";

import Button from "@/components/components/Button";
import { ButtonColor, ButtonSize } from "@/components/components/Button/button.enum";
import { LostConnection } from "@/components/icons";

interface IdleModalProps {
    type: "idle" | "lost-internet";
    show: boolean;
    onClose?: () => void;
    onOk?: () => void;
}

const Modal = ({ type, show, onClose, onOk }: IdleModalProps) => {

    const { t } = useTranslation();

    const baseClass = "modal";

    return (
        show && (
            <div className="modal__wrapper">
                <div className="modal">
                    <div className="modal__icon">
                        <LostConnection />
                    </div>
                    <div className="modal__header">{ type === "lost-internet" ? t("Oops! We lost you") : t("You’ve been inactive for some time.") }</div>
                    <div className="modal__text">
                        {type === "lost-internet" ? t("Try checking your internet connection") : t("Would you like to stay logged in?")}
                    </div>
                    <div className="modal__button-wrapper">
                        {type === "lost-internet" ? 
                            <Button id={"LOST_INTERNET_REFRESH_BUTTON"} className={`${baseClass}__modal-button`} onClick={onOk} ariaLabel={t("Lost Internet Refresh Button")}>
                                {t("Refresh")}
                            </Button>
                        :
                            <>
                                <Button
                                    id={"MODAL_CANCEL_BUTTON"}
                                    className={`${baseClass}__modal-button`}
                                    disabled={false}
                                    size={ButtonSize.REGULAR}
                                    border={false}
                                    color={ButtonColor.SECONDARY}
                                    onClick={onClose}
                                    ariaLabel={t("Log Out")}
                                >
                                    {t("Log Out")}
                                </Button>
                                <Button
                                    id={"MODAL_SUBMIT_BUTTON"}
                                    className={`${baseClass}__modal-button ${baseClass}__footer-button-wide`}
                                    size={ButtonSize.REGULAR}
                                    border={true}
                                    color={ButtonColor.PRIMARY}
                                    onClick={onOk}
                                    ariaLabel={t("Keep me logged in")}
                                >
                                    {t("Keep me logged in")}
                                </Button>
                            </>
                        }
                    </div>
                </div>
            </div>
        )
    );
};

export default Modal;
